<script>
// import Cleave from 'vue-cleave-component';

import processPaymentService from '@/services/Functions/processPaymentService';
// import cardsService from '@/services/Cards/cardsService';
import ordersService from '@/services/Orders/ordersService';
import pessoasService from '@/services/Pessoas/pessoasService';
import financingService from '@/services/Financing/financingService';
import logsService from '@/services/Logs/logsService';

import moment from 'moment';

import { CWLTipoPagamento } from '@/store/cwl_enums';
import { Circle2 } from 'vue-loading-spinner';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'payment-investment',
  components: {
    // Cleave,
    Circle2,
  },
  data() {
    return {
      paymentType: 'credit-card',
      card: {
        number: '',
        ownerName: '',
        dueDate: '',
        cvv: '',
      },
      options: {
        creditCard: true,
        delimiter: '-',
      },
      isBackActivate: false,
      isLoading: false,
      saveCard: false,
      savedCards: [],
      addNewCard: true,
      currentCardIndex: '',
      currentCardToken: '',
      userInformations: [],
      pessoa: {},
      boletoActive: false,
    };
  },
  validations: {
    card: {
      dueDate: {
        valid: value => {
          if (value == undefined) return false;
          var expireAt = moment(value, 'MM/YYYY').startOf('day');
          return expireAt.endOf('month').isSameOrAfter(moment().endOf('month'));
        },
      },
      number: {
        valid: required,
      },
      ownerName: {
        valid: required,
      },
      cvv: {
        valid: required,
      },
    },
  },
  computed: {
    order() {
      return this.$store.getters.getOrder;
    },
    financingId() {
      return this.$route.params.id;
    },
    loggedPessoa() {
      return this.$store.getters.getPessoa;
    },
    currentPessoa() {
      return this.$store.getters.getPessoa;
    },
  },
  mounted() {
    // this.checkHasCards();

    if (!this.loggedPessoa) {
      this.pessoa = this.$CWLNewPessoaPadrao();
    } else {
      this.getPessoa();
    }

    if (this.financingId) {
      this.get();
    }
  },
  methods: {
    nextStep() {
      this.$emit('nextStep');
    },

    async makePayment() {
      if (this.boletoActive == false && this.$v.$invalid) {
        return this.$toasted.show(
          'Informe os dados corretamente para processar o pagamento.',
          {
            icon: 'times',
            className: 'error',
            duration: 1000 * 7,
          },
        );
      }

      const order = {
        email: this.pessoa.email.email,
        cliente: this.pessoa.id,
        pessoa: this.pessoa,
        nome: this.financing.name,
        financing: this.financing,
        valor: this.order.item.order.totalValue,
        valorUnitario: this.order.item.order.unitValue,
        quantidade: this.order.item.order.quantityOfQuotas,
        boletoLink: '',
        boletoCodigoBarras: '',
        aceiteTermos: true,
        card: {
          numero: this.numeroCartao,
          nome: this.nomeCartao,
          validade: this.validadeCartao,
          codigo: this.codigoVerificadorCartao,
        },
      };
      if (this.boletoActive) {
        this.makePaymentBoleto(order);
      } else if (this.paymentType === 'credit-card') {
        this.makePaymentCartao(order);
      } else {
        this.makePaymentReserved(order);
      }
    },

    async updatePessoaInvestimentoNestaPlataforma(order) {
      const pessoaFromFirebase = await pessoasService.getPessoa(
        order.pessoa.id,
      );
      var pessoaNew = pessoaFromFirebase.data();
      pessoaNew.id = pessoaFromFirebase.id;
      if (
        !pessoaNew.dados_complementares.perfil.investimentos_nesta_plataforma
      ) {
        pessoaNew.dados_complementares.perfil.investimentos_nesta_plataforma = 0;
      }
      pessoaNew.dados_complementares.perfil.investimentos_nesta_plataforma +=
        order.valor;

      await pessoasService.updatePessoa(pessoaNew.id, pessoaNew);
    },

    async makePaymentCartao(order) {
      this.isLoading = true;

      order.item = {
        code: '001',
        description: order.nome,
        value: order.valorUnitario,
        quantity: order.quantidade,
      };

      const paymentData = {
        userId: order.cliente,
        financingId: order.financing.id,
        paymentKind: 'creditcard',
        items: [order.item],
        card: {
          holder: order.card.nome,
          cardNumber: order.card.numero,
          expirationDate: order.card.validade,
          securityCode: order.card.codigo,
          installmentQuantity: 1,
        },
      };

      try {
        const data = await processPaymentService.processPayment(paymentData);

        this.createNewOrder(
          CWLTipoPagamento.CartaoCredito,
          order,
          data,
        ).catch(error => console.error(error));
      } catch (error) {
        this.titleButtonContribuir = 'Contribuir';
        this.formDisabled = false;

        const message = error.message;

        this.$toasted.show(message, {
          icon: 'times',
          className: 'error',
        });
      }

      this.isLoading = false;
    },

    async makePaymentBoleto(order) {
      this.isLoading = true;

      const today = new Date();
      let dueDate = new Date();
      let dataEncerramentoStr = order.financing.dates.end_at;
      let dataEncerramento = moment(dataEncerramentoStr, 'YYYY/MM/DD');
      let diffDays = dataEncerramento.diff(today, 'days');
      if (diffDays >= 7) {
        dueDate.setDate(today.getDate() + 7);
      } else {
        dueDate.setDate(today.getDate() + diffDays);
      }

      const formmatedDueDate = dueDate.toLocaleString('pt-br').split(' ')[0];

      order.item = {
        code: '001',
        description: order.nome,
        value: order.valorUnitario,
        quantity: order.quantidade,
      };

      const paymentData = {
        userId: order.cliente,
        financingId: order.financing.id,
        paymentKind: 'bankslip',
        items: [order.item],
        bankSlip: {
          dueDate: formmatedDueDate,
          cancelAfterDue: false,
          isEnablePartialPayment: false,
          penaltyRate: 2.0,
          interestRate: 0.4,
          instruction:
            'Pague em qualquer agência bancária, lotérica ou internet banking.',
        },
      };

      try {
        const data = await processPaymentService.processPayment(paymentData);

        const taxUrl = data.BankSlipUrl;

        const slipObject = {
          bankSlipId: data.IdTransaction,
          paymentDate: data.DueDate,
          status: 'Pendente',
        };

        processPaymentService.createSlip(slipObject).catch(console.error);

        order.boletoLink = taxUrl;
        order.boletoVencimento = formmatedDueDate;
        order.boletoCodigoBarras = data.Barcode;

        this.createNewOrder(CWLTipoPagamento.Boleto, order, data).catch(
          console.error,
        );
      } catch (error) {
        this.titleButtonContribuir = 'Contribuir';
        this.formDisabled = false;
        const message = error.message;
        this.$toasted.show(message, {
          icon: 'times',
          className: 'error',
          duration: 1000 * 7,
        });
      }

      this.isLoading = false;
    },

    async makePaymentReserved(order) {
      this.isLoading = true;

      order.item = {
        code: '001',
        description: order.nome,
        value: order.valorUnitario,
        quantity: order.quantidade,
      };

      await this.createNewOrder(CWLTipoPagamento.Reservado, order, {});

      this.isLoading = false;
    },

    async createNewOrder(tipoPagamento, order, transaction) {
      console.debug('create new order', transaction);
      try {
        var transactionId = 0;
        var transactionToken = '';
        if (transaction) {
          transactionId = transaction.IdTransaction;
          transactionToken = transaction.Token ? transaction.Token : '';
        }
        const formattedOrder = {
          pessoa: order.pessoa,
          financing_id: this.financing.id,
          aceite_termos: true,
          // doacao_privada: order.doacaoPrivada,
          item: order.item,
          status:
            tipoPagamento == CWLTipoPagamento.Boleto ? 'Pendente' : 'Pago',
          tipo_pagamento: tipoPagamento,
          boleto_link: order.boletoLink,
          boleto_codigo_barras: order.boletoCodigoBarras,
          boleto_vencimento: order.boletoVencimento
            ? order.boletoVencimento
            : '',
          order_date: moment().format('YYYY/MM/DD HH:mm:ss'),
          transacao_id: transactionId,
          transacao_token: transactionToken,
        };

        if (tipoPagamento == CWLTipoPagamento.Boleto) {
          formattedOrder.status = 'Pendente';
        } else if (tipoPagamento == CWLTipoPagamento.CartaoCredito) {
          formattedOrder.status = 'Pago';
        } else {
          formattedOrder.status = 'Reservado';
        }

        formattedOrder.item.id = this.financing.id;

        const logUser = {
          user: {
            email:
              order.pessoa && order.pessoa.email
                ? order.pessoa.email.email
                : '',
          },
        };
        const logContent = formattedOrder;
        logsService.createNewLog(
          logUser,
          '',
          'Checkout - Pagar',
          '',
          logContent,
        );

        const orderCreated = await ordersService.createOrder(formattedOrder);

        if (tipoPagamento == CWLTipoPagamento.Boleto) {
          this.financing.totais.valor_pendente =
            this.financing.totais.valor_pendente + order.valor;
        } else if (tipoPagamento == CWLTipoPagamento.Reservado) {
          this.financing.totais.valor_reservado =
            this.financing.totais.valor_reservado + order.valor;
        } else {
          this.financing.totais.valor_investido =
            this.financing.totais.valor_investido + order.valor;
        }
        this.financing.totais.valor_total =
          this.financing.totais.valor_pendente +
          this.financing.totais.valor_reservado +
          this.financing.totais.valor_investido;

        await financingService.update(this.financing.id, this.financing);

        this.updatePessoaInvestimentoNestaPlataforma(order);

        const valorParsed = parseFloat(order.valor)
          .toFixed(2)
          .replace('.', ',');
        const valor =
          'R$ ' + valorParsed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        var objMail = {};
        if (tipoPagamento == CWLTipoPagamento.Boleto) {
          objMail = {
            email: formattedOrder.pessoa.email.email,
            name: formattedOrder.pessoa.nome,
            campanha_nome: this.financing.name,
            boleto_link: formattedOrder.boleto_link,
            boleto_codigo_barras: formattedOrder.boleto_codigo_barras,
            boleto_valor: valor,
            boleto_vencimento: formattedOrder.boleto_vencimento,
          };
          await this.$CWLsendMailFinalizarCompraBoleto(objMail);
        } else if (tipoPagamento == CWLTipoPagamento.Reservado) {
          objMail = {
            email: formattedOrder.pessoa.email.email,
            name: formattedOrder.pessoa.nome,
            campanha_nome: this.financing.name,
            reserva_valor: valor,
          };
          await this.$CWLsendMailFinalizarCompraReservado(objMail);
        } else {
          objMail = {
            email: formattedOrder.pessoa.email.email,
            name: formattedOrder.pessoa.nome,
            campanha_nome: this.financing.name,
            cartao_valor: valor,
          };
          this.$CWLsendMailFinalizarCompraCartao(objMail);
        }

        this.$router.push('/obrigado/' + orderCreated.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show(
          'Ocorreu um erro durante o pagamento, tente novamente.',
          {
            icon: 'times',
            className: 'error',
          },
        );

        this.titleButtonContribuir = 'Contribuir';
        this.formDisabled = false;
      }
    },

    // async checkHasCards() {
    //   const existentCards = await cardsService.checkHasSavedCards(
    //     this.loggedInUser.email
    //   );

    //   existentCards.forEach(card => {
    //     const newCard = card.data();

    //     this.savedCards.push(newCard);
    //   });

    //   if (this.savedCards.length) {
    //     this.addNewCard = false;
    //   }
    // },
    selectActiveCard(index) {
      this.currentCardIndex = index;
      const currentCard = this.savedCards[index];
      this.currentCardToken = this.savedCards[index].card.Token;

      this.card.number = `*********** ${currentCard.savedInformations.card}`;
      this.card.ownerName = currentCard.savedInformations.holder;
      this.card.dueDate = '**/**';
      this.card.cvv = '***';
    },
    enableToAddNewCard() {
      this.addNewCard = true;

      this.card = {
        number: '00000000000',
        ownerName: 'Seu Nome',
        dueDate: '00/0000',
        cvv: '000',
      };
    },
    async getPessoa() {
      const { pessoa_id } = this.loggedPessoa;
      const pessoa = await pessoasService.getPessoa(pessoa_id);

      this.pessoa = pessoa.data();
      this.pessoa.id = pessoa.id;
    },

    async get() {
      this.financing = await financingService.findById(this.financingId);

      this.isLoading = false;

      await this.calculosDaCampanha(this.financing);
    },
    async calculosDaCampanha(financ) {
      return this.$CWLCampanhaCalculos(financ);
    },
  },
};
</script>

<template>
  <div class="payment">
    <div class="payment-informations">
      <h4>Informações de Pagamento</h4>
      <p>
        Selecione a forma de pagamento, e preencha com seus dados
      </p>

      <div class="payment-type-buttons">
        <button
          class="button"
          :class="{ 'is-activated': paymentType === 'credit-card' }"
          @click="
            paymentType = 'credit-card';
            boletoActive = false;
          "
        >
          <i class="fas fa-check"></i>
          Cartão de Crédito
        </button>

        <button
          class="button tax-button"
          :class="{ 'is-activated': paymentType === 'tax' }"
          @click="
            paymentType = 'tax';
            boletoActive = true;
          "
        >
          <i class="fas fa-check"></i>
          Boleto Bancário
        </button>

        <!-- <button
          class="button tax-button"
          :class="{ 'is-activated': paymentType === 'reserva' }"
          @click="paymentType = 'reserva'; boletoActive = false"
        >
          <i class="fas fa-check"></i>
          Reservar Investimento
        </button> -->
      </div>

      <div class="card-informations" v-if="paymentType == 'credit-card'">
        <!-- <div class="card" :class="{ 'is-turn': isBackActivate }">
          <div class="front">
            <span class="card-number">
              {{ card.number }}
            </span>

            <div class="card-column">
              <span class="owner-name">
                <small>Nome como está no Cartão</small>
                <span>
                  {{ card.ownerName }}
                </span>
              </span>

              <span class="due-date">
                <small>Validade</small>
                {{ card.dueDate }}
              </span>
            </div>
          </div>

          <div class="back">
            <span class="back-line"></span>

            <span class="cvv">
              <small>CVV</small>
              {{ card.cvv }}
            </span>
          </div>
        </div> -->

        <div class="card-form" v-if="savedCards.length && !addNewCard">
          <div class="saved-cards-list">
            <div>
              <div
                class="card-item"
                v-for="(card, index) in savedCards"
                :key="card.card.Token"
                @click="selectActiveCard(index)"
                :class="{ activeCard: currentCardIndex === index }"
              >
                <i
                  class="fas fa-check-circle"
                  v-if="currentCardIndex === index"
                ></i>
                <span class="card-number">
                  ******** {{ card.savedInformations.card }}
                </span>
              </div>
            </div>
            <div
              class="card-item new-card-button"
              @click="enableToAddNewCard()"
            >
              <i class="fas fa-plus-circle"></i>
              <span class="new-card">
                Adicionar Cartão
              </span>
            </div>

            <button
              class="button finish"
              @click="cardCheckout()"
              :class="{ 'in-process': isLoading }"
            >
              <i class="fas fa-lock" v-if="!isLoading"></i>
              <circle-2 v-if="isLoading"></circle-2>
              Finalizar Compra
            </button>
          </div>
        </div>

        <div class="card-form" v-if="!savedCards.length || addNewCard">
          <span
            class="saved-cards-back"
            v-if="savedCards.length && addNewCard"
            @click="addNewCard = false"
          >
            <i class="fas fa-arrow-left"></i>
            Voltar para cartões salvos
          </span>

          <div class="column" @click="isBackActivate = false">
            <label>N° do Cartão</label>
            <input
              type="text"
              class="input"
              name="card"
              placeholder="0000-0000-0000-0000"
              v-model="card.number"
              v-mask="'####-####-####-####'"
            />
          </div>

          <div class="column">
            <label>Nome como no Cartão</label>
            <input
              @click="isBackActivate = false"
              type="text"
              class="input"
              placeholder="Nome do Cartão"
              v-model="card.ownerName"
            />
          </div>

          <div class="columns">
            <div class="column">
              <label>Validade</label>
              <input
                @click="isBackActivate = false"
                v-mask="'##/####'"
                type="text"
                class="input"
                placeholder="12/2026"
                v-model="card.dueDate"
              />
            </div>

            <div class="column">
              <label>CVV</label>
              <input
                @click="isBackActivate = true"
                type="text"
                class="input"
                placeholder="000"
                v-mask="'###'"
                v-model="card.cvv"
              />
            </div>
          </div>

          <!-- <div class="column save-card">
            <input type="checkbox" required v-model="saveCard" />
            <label>Salvar o Cartão</label>
          </div> -->

          <div class="column">
            <button
              class="button finish"
              @click="makePayment()"
              :class="{ 'in-process': isLoading }"
            >
              <i class="fas fa-lock" v-if="!isLoading"></i>
              <circle-2 v-if="isLoading"></circle-2>
              Finalizar Compra
            </button>
          </div>
          <div class="column">
            <div class="form-group">
              <div class="error" v-if="$v.$invalid">
                Informe todos os campos.
              </div>
              <div
                class="error"
                v-if="card.dueDate != '' && !$v.card.dueDate.valid"
              >
                Informe um mês e ano válido.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="investment-informations">
      <h5>
        <i class="fas fa-wallet"></i>
        Resumo do Investimento
      </h5>

      <div class="column">
        <label>
          Nome do Investimento
        </label>
        {{ order.item.name }}
      </div>

      <div class="column total">
        <label>Total:</label>
        {{ order.item.order.totalValue | currency }}
      </div>

      <button
        class="button finish"
        @click="makePayment()"
        :class="{ 'in-process': isLoading }"
        v-if="paymentType !== 'credit-card'"
      >
        <i class="fas fa-lock" v-if="!isLoading"></i>
        <circle-2 v-if="isLoading"></circle-2>
        Finalizar Compra
      </button>
    </div>
  </div>
</template>
